const pendingRequests = new Map();
let _initialized = false;
const timeout = 2_000;

// Hard switch to keep the old/new hub iframe bridge present but fully inert.
export const iframeRequestSystemEnabled = false;

export function IframeRequests(opcode: string, payload?: unknown) {
  if (!iframeRequestSystemEnabled) return Promise.resolve(null);

  const requestId = crypto.randomUUID();

  const resolvers = Promise.withResolvers();
  pendingRequests.set(requestId, resolvers);

  try {
    window.parent?.postMessage({
      requestId,
      opcode,
      payload,
    }, import.meta.env.VITE_OLD_HUB_URL);
  } catch(e) {
    pendingRequests.delete(requestId);
    console.error(e);
    return Promise.reject(e);
  }

  // Set up a timeout to reject the promise if no response is received
  const timer = setTimeout(() => {
    if (pendingRequests.has(requestId)) {
      pendingRequests.delete(requestId);
      resolvers.reject(new Error(`Request timed out (${requestId}, ${opcode})`));
    }
  }, timeout);

  // Clear the timeout if the promise is resolved or rejected
  resolvers.promise.finally(() => clearTimeout(timer));

  return resolvers.promise;
}

export function startListener() {
  if (!iframeRequestSystemEnabled) return;
  if (_initialized) return;
  _initialized = true;
  window.addEventListener('message', handleEvent);
}
export function stopListener() {
  if (!iframeRequestSystemEnabled) return;
  window.removeEventListener('message', handleEvent);
}

function handleEvent(event: MessageEvent) {
  // Security check: only accept messages from allowed origins
  if (!isAllowedOrigin(event.origin)) return;
  console.log("New hub received message", event);

  const { requestId, error = null, payload = null } = event.data;
  if (!requestId) return;
  if (!pendingRequests.has(requestId)) return;

  const resolvers = pendingRequests.get(requestId);
  pendingRequests.delete(requestId);

  if (error) resolvers.reject(error);
  else resolvers.resolve(payload);
}

function isAllowedOrigin(origin: string): boolean {
  // We want to allow the old hub to communicate with the new hub, and from our localhost
  if (origin === import.meta.env.VITE_OLD_HUB_URL) return true;
  if (origin === "http://localhost:8080") return true;

  console.log("Received unauthorized postMessage request from", origin);
  return false;
}
